import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '../environments/environment';

import { ReturnsComponent } from '../app/static/returns/returns.component';
import { ContactComponent } from '../app/static/contact/contact.component';
import { FaqComponent } from '../app/static/faq/faq.component';
import { PrivacyComponent } from '../app/static/privacy/privacy.component';


const routes: Routes = [
  { path: '', redirectTo: 'products', pathMatch: 'full' },
  { path: 'products', loadChildren: 'app/products/products.module#ProductsModule'},
  { path: 'categories/:category/products', loadChildren: 'app/products/products.module#ProductsModule'},
  { path: 'cart', loadChildren: 'app/cart/cart.module#CartModule' },
  { path: 'checkout', loadChildren: 'app/checkout/checkout.module#CheckoutModule' },
  { path: 'contact', component: ContactComponent},
  { path: 'faq', component: FaqComponent },
  { path: 'returns', component: ReturnsComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'products' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: !environment.production})],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts